import * as React from "react";
import styled, { css } from "styled-components";
import i18n from "i18n";
import Icon from "components/common/Icon";
import { AGGREGATION_WIDGET_TYPE } from "ai/widget-summary/createWidgetSummaryRequest";
import { MESSAGES_WIDGET_TYPE } from "ai/widget-summary/createMessagesWidgetSummaryRequest";
const Container = styled.div(
  ({ theme, $size }) => css`
    align-items: center;
    background-color: ${$size === "compact" ? theme.colors.background.body : theme.colors.background.secondaryNav};
    border-radius: 4px;
    display: flex;
    gap: ${$size === "compact" ? theme.spacings.xs : theme.spacings.sm};
    padding: ${$size === "compact" ? theme.spacings.xs : theme.spacings.sm};
  `
);
const IconContainer = styled.div(
  ({ theme, $size }) => css`
    align-items: center;
    background-color: ${$size === "compact" ? theme.colors.background.secondaryNav : theme.colors.background.body};
    border-radius: 4px;
    color: ${theme.colors.variant.info};
    display: flex;
    flex: 0 0 auto;
    height: ${theme.spacings.lg};
    justify-content: center;
    width: ${theme.spacings.lg};
  `
);
const TextContainer = styled.div`
  min-width: 0;
`;
const Title = styled.div`
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const Metadata = styled.div(
  ({ theme }) => css`
    color: ${theme.colors.text.secondary};
    font-size: ${theme.fonts.size.small};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `
);
const messageCount = (request) => {
  var _a;
  return (_a = request.payload.selection) == null ? void 0 : _a.messages.length;
};
const metadataForRequest = (request) => {
  var _a, _b;
  const selectedMessages = messageCount(request);
  if (selectedMessages !== void 0) {
    return i18n.t("assistant_attachment.selected_messages", { ns: "enterprise_ai", count: selectedMessages });
  }
  if (((_a = request.payload.config) == null ? void 0 : _a.type) === MESSAGES_WIDGET_TYPE) {
    return i18n.t("assistant_attachment.message_table", { ns: "enterprise_ai" });
  }
  if (((_b = request.payload.config) == null ? void 0 : _b.type) === AGGREGATION_WIDGET_TYPE) {
    return i18n.t("assistant_attachment.aggregation_widget", { ns: "enterprise_ai" });
  }
  return i18n.t("assistant_attachment.widget", { ns: "enterprise_ai" });
};
const iconForRequest = (request) => {
  var _a, _b;
  if (request.payload.selection) {
    return "data_table";
  }
  if (((_a = request.payload.config) == null ? void 0 : _a.type) === MESSAGES_WIDGET_TYPE) {
    return "table_chart";
  }
  if (((_b = request.payload.config) == null ? void 0 : _b.type) === AGGREGATION_WIDGET_TYPE) {
    return "monitoring";
  }
  return "analytics";
};
const AssistantAttachment = ({ request, size = "default" }) => {
  var _a;
  if (!((_a = request.payload) == null ? void 0 : _a.name)) {
    return null;
  }
  const details = metadataForRequest(request);
  return /* @__PURE__ */ React.createElement(Container, { $size: size }, /* @__PURE__ */ React.createElement(IconContainer, { $size: size }, /* @__PURE__ */ React.createElement(Icon, { name: iconForRequest(request) })), /* @__PURE__ */ React.createElement(TextContainer, null, /* @__PURE__ */ React.createElement(Title, { title: request.payload.name }, request.payload.name), details && /* @__PURE__ */ React.createElement(Metadata, null, details)));
};
export default AssistantAttachment;
